import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/react'
import './index.css'
import App from './App.jsx'
import { DEV_NO_AUTH } from './lib/devMode'

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// In dev mode (no Clerk key) we skip ClerkProvider entirely so the app boots
// without a Clerk instance. Production sets the key and gets real auth.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    {DEV_NO_AUTH ? (
      <App />
    ) : (
      <ClerkProvider publishableKey={clerkPubKey} afterSignOutUrl="/login">
        <App />
      </ClerkProvider>
    )}
  </StrictMode>,
)
